import {UI} from "../../../../stem-core/src/ui/UIBase";

import {styleRuleInherit} from "stem-core/src/ui/Style";
import {styleRule} from "stem-core/src/decorators/Style";
import {registerStyle} from "stem-core/src/ui/style/Theme";
import {Messages} from "../../../Messages";
import {isSmallScreen} from "../../../UtilsLib";
import {CDSAccountLookup} from "./CDSAccountLookup.jsx";
import {BasePanelPageStyle} from "../../PanelPage";
import {AuthStartPanel, AuthStartPanelStyle} from "../../../website/unauthenticated/slides/AuthStartPanel.jsx";
import {AuthPanelPage} from "../../pages/panels/AuthPanelPage.jsx";
import {Router} from "../../../../stem-core/src/ui/Router.jsx";
import {LOGIN_WITH_EMAIL_CODE_URL} from "../../../Constants.js";


class CDSAuthPageStyle extends BasePanelPageStyle {
    @styleRuleInherit
    content = {
        width: null
    }

    @styleRuleInherit
    panelPage = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    };

    @styleRuleInherit
    panelPagePopup = {
        padding: "0 18 0 0 important",
        marginBottom: 18,
    };

    @styleRule
    authContainer = {
        display: "flex",
        flexDirection: () => isSmallScreen() ? "column" : "row",
        marginBottom: -4,
    };

    @styleRule
    authColumn = {
        flex: 1,
        ":first-child": {
            marginRight: () => isSmallScreen() ? 0 : 36,
        },
        ":last-child": {
            marginLeft: () => isSmallScreen() ? 0 : 36,
        },
    };

    @styleRule
    authCDSDescription = {
        textAlign: "center",
        marginBottom: 32,
    };

    @styleRule
    authHomeTitle = this.themeProps.PANEL_AUTH_PANEL_TITLE;

    @styleRule
    socialButtons = {
        width: 282,
        textAlign: "center",
        margin: "0 auto 18px",
    };

    @styleRule
    link = {
        color: this.themeProps.MERCHANT_LINK,
        textTransform: "lowercase",
        cursor: "pointer",
    };

    @styleRule
    lineSeparator = {
        marginBottom: 18,
    };

    @styleRule
    smallScreenSeparator = {
        display: () => isSmallScreen() ? "block" : "none",
        marginTop: -6,
        marginBottom: 18,
    };

    @styleRule
    bottomSection = {
        marginTop: 6,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    };

    @styleRule
    verticalLine = {
        width: 1,
        background: "#E3E3E3",
        marginBottom: 14,
    };

    @styleRule
    authHomeTerms = {
        marginBottom: -18,
    }
}


class CDSAuthStartPanelStyle extends AuthStartPanelStyle {
    @styleRule
    footerSection = {
        textAlign: "center",
    }
}


@registerStyle(CDSAuthStartPanelStyle)
class CDSAuthStartPanel extends AuthStartPanel {
    render() {
        const styleSheet = CDSAuthPageStyle.getInstance();
        return [
            <div className={styleSheet.authContainer}>
                <div className={styleSheet.authColumn}>
                    {this.getHeaderSection()}
                    {this.getEmailInputSection()}
                </div>
                <div className={styleSheet.verticalLine}></div>
                <div className={styleSheet.authColumn}>
                    <div className={styleSheet.authHomeTitle}>{Messages.lookUpPrintMagazineTitle}</div>
                    <div className={styleSheet.authCDSDescription}>{Messages.lookUpPrintMagazineDescription}</div>
                    <CDSAccountLookup/>
                </div>
            </div>,
            this.getFooterSection()
        ]
    }
}

@registerStyle(CDSAuthPageStyle)
export class CDSAuthPage extends AuthPanelPage {
    getFlowOptions() {
        return {
            AuthStartPanelClass: CDSAuthStartPanel,
            onEmailCodeRequested: () => Router.changeURL(LOGIN_WITH_EMAIL_CODE_URL), // TODO @auth @cleanup still needs to be merged with the regular flow. Ok for now.
        }
    }
}
